import { QueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";

/**
 * Qayta urinmaydigan javoblar: bular tarmoq nosozligi emas, javobning
 * o'zi. 401/403 — huquq masalasi (interceptor token'ni o'zi yangilaydi),
 * 404 — resurs yo'q. Bularni takrorlash faqat kutishni uzaytiradi.
 */
const NO_RETRY_STATUSES = new Set([401, 403, 404]);

export const shouldRetryQuery = (failureCount: number, error: unknown): boolean => {
  const status = (error as AxiosError | undefined)?.response?.status;
  if (status && NO_RETRY_STATUSES.has(status)) return false;
  return failureCount < 2;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,

      /**
       * Ilgari `staleTime: 0` edi: har bir ro'yxatning HAR BIR mount'i
       * so'rov yuborardi — ekranlar orasida u-bu qilib yurish o'nlab
       * ortiqcha so'rovga aylanardi. Yangilikni mutatsiyalardagi
       * `invalidateQueries` ta'minlaydi, poll emas; tez eskiradigan
       * so'rovlar (masalan, `useCourseReadiness`) o'zida `staleTime: 0` ni
       * saqlab qolgan.
       */
      staleTime: 60_000,
      gcTime: 5 * 60_000,

      /**
       * Ilgari `retry: false` edi: bitta yo'qolgan paket darhol xato
       * toast'iga aylanardi. Endi vaqtinchalik nosozlik jimgina qayta
       * urinib ko'riladi, javobning o'zi aytgan xato esa — yo'q.
       */
      retry: shouldRetryQuery,
    },
  },
});
